import { BeneficiaryDetailsRecord } from "@zenith/services/user";

/**
 * The BeneficiaryDetailsRecordWithDisplayName interface.
 * @typedef
 * @name BeneficiaryDetailsRecordWithDisplayName
 * @kind variable
 */
type BeneficiaryDetailsRecordWithDisplayName = BeneficiaryDetailsRecord & {
  displayName: string;
};

/**
 * Adds a display name to a beneficiary record data.
 * @function
 * @name handleBeneficiary
 * @kind function
 * @param {BeneficiaryDetailsRecord} beneficiary The Beneficiary Details Record.
 * @returns {BeneficiaryDetailsRecordWithDisplayName} Updated Beneficiary Details Record with Display name.
 * @exports
 */
export function handleBeneficiary(
  beneficiary: BeneficiaryDetailsRecord
): BeneficiaryDetailsRecordWithDisplayName {
  return {
    ...beneficiary,
    displayName: (beneficiary.beneficiaryNickName ||
      beneficiary.beneficiaryName) as string,
  };
}
